import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CartPrice from "./CartPrice";
import CartTotalPrice from "./CartTotalPrice";
import NumberInputForCart from "./NumberInputForCart";
import {
  deletProductsToCart,
  fetchUserData,
  setUser,
} from "../../redux/actions";

const CartRow = ({ refreshCart, cartId, index, ...item }) => {
  const [quantity, setQuantity] = useState();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const user_data = useSelector((state) => state?.user_data?.user_data) ?? {};

    useEffect(() => {
        setQuantity(item?.quantity ?? 1);
    }, [item?.quantity]);

    const removeCartItem = async () => {
        setLoading(true);
        const data = await deletProductsToCart(cartId, item?.product_variation, 0);

        if (data) {
            if(user_data?.name) {
                const user = await fetchUserData();
                if (user) {
                    dispatch(setUser(user));
                    refreshCart();
                    setLoading(false);
                } 
            } else {
                refreshCart();
                setLoading(false);
            }
        }
    };

  return (
    <tr key={item?.id}>
      <td className="px-20 py-12 border-end border-neutral-100">
        <div className="table-product d-flex align-items-center gap-24">
          {item?.product_variation?.product?.jasani_image_url && (
            <img
              src={item?.product_variation?.product?.jasani_image_url}
              className="w-72"
              alt="jasani_image"
            />
          )}
          {!item?.product_variation?.product?.jasani_image_url && (
            <img
              src={
                item?.product_variation?.images?.[0]?.files?.medium?.url ||
                "/assets/images/logo/Image-coming-soon.png"
              }
              className="w-72"
              alt="product_image"
            />
          )}
        </div>
      </td>
      <td className="px-30 py-16 border-end border-neutral-100">
        <div className="table-product__content text-start">
          <h6
            style={{ width: "170px" }}
            className="title text-lg fw-semibold mb-8"
          >
            {item?.product_variation?.product?.name}
          </h6>
          <div className="overflow-hidden overflow-ellipsis whitespace-nowrap">
            {item?.product_variation?.attributes?.[0]?.value ? (
                <>{item?.product_variation?.attributes?.[0]?.value}</>
            ) : (
                <></>
            )}
            {item?.product_variation?.attributes?.[0]?.unit ? (
                <>{item?.product_variation?.attributes?.[0]?.unit}</>
            ) : (
                <></>
            )}
            
          </div>
        </div>
      </td>
      <td className="px-20 py-12 border-end border-neutral-100">
        <NumberInputForCart
          value={quantity}
          onChange={(e) => setQuantity(Number(e.target.value))}
          cartId={cartId}
          product_variation={item?.product_variation}
          refreshCart={refreshCart}
        />
      </td>
      <td className="px-20 py-12 border-end border-neutral-100">
        <div className="table-product__content text-start">
            <span className="text-lg h6 mb-0 fw-semibold">
                <CartPrice
                    product_variation={item?.product_variation}
                    quantity={item?.quantity}
                />
            </span>
        </div>
      </td>
      <td className="px-20 py-12 border-end border-neutral-100">
        <div className="table-product__content text-start">
            <span className="text-lg h6 mb-0 fw-semibold">
                <CartTotalPrice
                    product_variation={item?.product_variation}
                    quantity={item?.quantity}
                />
            </span>
        </div>
      </td>
        <td className="px-20 py-12 border-end border-neutral-100">
            <div className="d-flex align-items-center justify-content-center h-100">
                {loading ? (
                    <i className="ph ph-spinner animate-spin text-2xl" />
                ) : (
                    <Link
                        className="w-52 h-52 text-center rounded-circle hover-text-danger-600 d-flex align-items-center justify-content-center"
                        onClick={removeCartItem}
                        disabled={loading}
                    >
                        <i className="ph ph-x-circle text-2xl" />
                    </Link>
                )}
            </div>
        </td>
    </tr>
  );
};

export default CartRow;
